import { combineReducers } from '@reduxjs/toolkit'
import data from './dataSlice'
import state from './stateSlice'
const farmerReducer = combineReducers({
    data,
    state
})

export default farmerReducer;